<style>
	:global(#color > .mdc-floating-label) {
		left: 50px !important;
	}
</style>

<script lang="ts">
	import Button, { Label } from '@smui/button';
	import Card from '@smui/card';
	import Select, { Option } from '@smui/select';
	import Input from '@smui/textfield';
	import { _ } from 'svelte-i18n';
	import { writable } from 'svelte/store';
	import FormLoading from '../../../..//shared/components/common/Loading/FormLoading.svelte';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import Area from '../../../../shared/models/Area/Area';
	import FiltroAllegatoLayerGis from '../../../../shared/models/Filtri/FiltroAllegatoLayerGis';
	import LayerGis from '../../../../shared/models/LayerGis/LayerGis';
	import { hasRoleAreaManager, hasRoleSysAdmin } from '../../../../shared/stores';
	import FieldLoading from './../../../..//shared/components/common/Loading/FieldLoading.svelte';

	export let params = {
		id: '0',
	};

	let [data, loading, error] = LayerGis.get(params.id);
	let [dataForUpload, loadingForUpload, errorForUpload] = [null, writable(false), null];
	let [dataAree, loadingAree, errorAree] = Area.getList();

	let selectedArea: Area = new Area();
	$: if (selectedArea && selectedArea.id && selectedArea.id > 0) {
		$data.areaId = selectedArea.id;
	} else {
		if ($data?.areaId) {
			selectedArea = $dataAree?.response?.find((x) => x?.id === $data?.areaId);
		}
	}

	let newAllegati = [];

	function selectUpload() {
		const uploaderInput = document.getElementById('uploader-input');
		newAllegati = Array.from(uploaderInput.files);
		uploaderInput.value = '';
	}
	function uploadFile() {
		document.getElementById('uploader-input').click();
	}

	function onSubmit() {
		if (newAllegati?.[0]?.name) {
			$data.allegati = null;
			$data.area = null;
			[dataForUpload, loadingForUpload, errorForUpload] = LayerGis.save($data);
			setTimeout(async () => {
				const formData = new FormData();
				formData.append('sourceid', $dataForUpload.id);
				formData.append('context', 'LayerGis');
				formData.append('file', newAllegati[0]);
				const request = await fetch('api/upload/files', { method: 'POST', body: formData });
				let response = await request.json();
				setTimeout(async () => {
					[data, loading, error] = await LayerGis.addAttachment(<FiltroAllegatoLayerGis>{
						layerGisId: $dataForUpload.id,
						idFile: response.response?.idFile,
						nomeFile: newAllegati[0].name.replace(/\s/g, ''),
					});
				}, 1000);
			}, 1000);
		} else {
			$data.allegati = null;
			$data.area = null;
			[data, loading, error] = LayerGis.save($data);
		}
	}
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.layers.detail.title')}" />
		<div class="sm:flex-nowrap sm:space-x-4 flex flex-wrap">
			<!-- 
                Se l'utente ha il ruolo di Area Manager disabilita button di salvataggio se non è presente un allegato ed una descrizione.
                Se l'utente ha il ruolo di Sys Admin disabilita button di salvataggio se non è presente un allegato, una descrizione e un'area.
            -->
			<button
				type="submit"
				form="form"
				class="btn-white h-14 w-14 sm:h-16 sm:w-16"
				disabled="{($hasRoleSysAdmin &&
					(!$data.areaId || !$data.descrizione || (!$data.allegati?.[0]?.nome && !newAllegati?.[0]?.name))) ||
					($hasRoleAreaManager && (!$data.descrizione || (!$data.allegati?.[0]?.nome && !newAllegati?.[0]?.name)))}"
			>
				<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
			</button>
		</div>
	</div>
	{#if $loading}
		<FormLoading />
	{:else}
		<form on:submit|preventDefault="{onSubmit}" id="form" class="md:grid-cols-3 grid grid-cols-1">
			<Input
				required
				label="{$_('page.layers.detail.description')}"
				bind:value="{$data.descrizione}"
				name="descrizione"
				class="md:col-start-2"
			/>
			{#if $hasRoleSysAdmin}
				{#if $loadingAree}
					<FieldLoading customClass="md:col-start-2" />
				{:else}
					<Select
						required
						label="{$_('page.layers.detail.area')}"
						key="{(area) => `${(area && area?.id) || ''}`}"
						bind:value="{selectedArea}"
						class="md:col-start-2"
					>
						{#if $dataAree.response}
							{#each $dataAree.response as area (area?.id)}
								{#if area?.nomeComune}
									<Option
										value="{area}"
										on:click="{() => {
											$data.area = area;
											$data.areaId = area.id;
										}}">{area.nomeComune}</Option
									>
								{/if}
							{/each}
						{/if}
					</Select>
				{/if}
			{/if}
			<Input id="color" bind:value="{$data.colore}" label="Colore" class="md:col-start-2">
				<input type="color" bind:value="{$data.colore}" slot="leadingIcon" />
			</Input>
		</form>
		<label id="upload-container" for="uploader-input" class="flex self-center">
			<Button on:click="{uploadFile}" type="button" variant="raised" class="mt-3.5 w-36 p-2.5 text-base">
				<Label class="text-sm">{$_('global.select_file')}</Label>
			</Button>
			{#if newAllegati?.[0]?.name || ($data?.allegati?.[0]?.nome && newAllegati?.[0]?.name)}
				<Input required class="ml-2" input$readonly value="{newAllegati[0].name}" />
			{:else if $data?.allegati?.[0]?.nome}
				<Input required class="ml-2" input$readonly value="{$data.allegati[0].nome}" />
			{:else}
				<Input required class="ml-2" input$readonly value="{$_('global.no_file_selected')}" />
			{/if}
		</label>
		<input required hidden type="file" id="uploader-input" bind:files="{newAllegati}" on:change="{selectUpload}" />
	{/if}
</Card>
